export default {
  "Source saved. Existing content is updating in the background.": "Source saved. Existing content is updating in the background.",
  "Source saved, but the existing content update could not be queued.": "Source saved, but the existing content update could not be queued.",
  "Source saved; some existing content could not be updated.": "Source saved; some existing content could not be updated.",
  "Existing content update completed.": "Existing content update completed.",
  "Content batches processed": "Content batches processed",
  "Update existing content": "Update existing content",
  "Choose how to update existing content": "Choose how to update existing content",
  "Only these changes": "Only these changes",
  "Keep other assignments.": "Keep other assignments.",
  "Match new selections": "Match new selections",
  "Removes other assignments.": "Removes other assignments.",
  "How do these differ?": "How do these differ?",
  "Update queued": "Update queued",
  "Updating existing content": "Updating existing content",
  "Update complete": "Update complete",
  "Update failed": "Update failed",
  "You can close this dialog and return later.": "You can close this dialog and return later.",
  "updated": "updated",
  "unchanged": "unchanged",
  "No changes were saved.": "No changes were saved.",
  "View details": "View details",
  "Applied networks:": "Applied networks:",
  "Applied tags:": "Applied tags:",
  "Close": "Close",
  "Tags": "Tags",
  "Networks": "Networks",
  "Replace existing assignments": "Replace existing assignments",
  "Make existing content match the new selections for changed tags or networks. Manual and unrelated assignments will be removed.": "Make existing content match the new selections for changed tags or networks. Manual and unrelated assignments will be removed.",
  "Changed dimensions:": "Changed dimensions:",
  "Final tags:": "Final tags:",
  "Final networks:": "Final networks:",
  "Only changed dimensions will be replaced. Unchanged tags or networks will be preserved.": "Only changed dimensions will be replaced. Unchanged tags or networks will be preserved.",
  "Manual and unrelated assignments in the changed dimensions will be removed. Empty selections clear those assignments. This cannot be undone.": "Manual and unrelated assignments in the changed dimensions will be removed. Empty selections clear those assignments. This cannot be undone.",
  "Replace existing assignments?": "Replace existing assignments?",
  "Replace assignments": "Replace assignments",
  "Loading current source settings...": "Loading current source settings...",
  "Source settings could not be loaded. Retry before editing.": "Source settings could not be loaded. Retry before editing.",
  "Retry loading": "Retry loading",
  "Previous tags:": "Previous tags:",
  "Pending tags:": "Pending tags:",
  "Apply tag and network changes to existing {{ count }} content item": "Apply tag and network changes to existing {{ count }} content item",
  "Apply tag and network changes to existing {{ count }} content items": "Apply tag and network changes to existing {{ count }} content items",
  "Apply only tag and network additions or removals made in this update. Other assignments stay unchanged. Differences from older updates are not repaired. This cannot be undone.": "Apply only tag and network additions or removals made in this update. Other assignments stay unchanged. Differences from older updates are not repaired. This cannot be undone.",
  /*
    SociuuHub platform pages
  */

  // Login
  "Sign In": "Sign In",
  "Email": "Email",
  "Password": "Password",
  "Submit": "Submit",
  "Forgot password?": "Forgot password?",
  "Reset password": "Reset password",
  "If you do not get an email from us within a few minutes be sure to check your spam filter.": "If you do not get an email from us within a few minutes be sure to check your spam filter.",
  "Back to login": "Back to login",

  // Magic Login Page
  "Sign in to SociuuHub": "Sign in to SociuuHub",
  "To make life easy we've skipped lengthy and difficult passwords. Enter your email and check your inbox for an email with a login link.": "To make life easy we've skipped lengthy and difficult passwords. Enter your email and check your inbox for an email with a login link.",
  "To make life easy we've skipped lengthy and difficult passwords. Enter your email or number and check your inbox for an email or message with a login link.": "To make life easy we've skipped lengthy and difficult passwords. Enter your email or number and check your inbox for an email or message with a login link.",
  "Email Address": "Email Address",
  "Email is required.": "Email is required.",
  "Invalid Email": "Invalid Email",
  "Enter email or mobile number": "Enter email or mobile number",
  "Email or number is required.": "Email or number is required.",
  "Email or number is invalid.": "Email or number is invalid.",
  "Send magic link": "Send magic link",
  "Welcome to your<br/>Content Hub": "Welcome to your<br/>Content Hub",
  "This is your personal Content Hub, where you will find our latest news, social media posts, and job listings that you can share with your network.": "This is your personal Content Hub, where you will find our latest news, social media posts, and job listings that you can share with your network.",
  "To make life easy we’ve skipped lengthy and difficult passwords. Sign in with your Microsoft account, or enter your email to receive a login link.": "To make life easy we’ve skipped lengthy and difficult passwords. Sign in with your Microsoft account, or enter your email to receive a login link.",
  "To make life easy we’ve skipped lengthy and difficult passwords. Simply sign in with your Microsoft account to access your SociuuHub.": "To make life easy we’ve skipped lengthy and difficult passwords. Simply sign in with your Microsoft account to access your SociuuHub.",

  // Magic Verify Page
  "Verifying user!": "Verifying user!",

  // Signup Page
  "Signup": "Signup",
  "Signin": "Signin",
  "Already have an account?": "Already have an account?",
  "First name": "First name",
  "Last name": "Last name",
  "Email address": "Email address",
  "Phone": "Phone",
  "Department": "Department",
  "Department is required": "Department is required",
  "I agree to the": "I agree to the",
  "Welcome to": "Welcome to",
  "Create your account": "Create your account",
  "Invalid phone number": "Invalid phone number",
  "Allowed domains i.e;": "Allowed domains i.e;",
  "Email address or Phone number is required": "Email address or Phone number is required",
  "Invalid domain": "Invalid domain",
  "Please enter a valid email address": "Please enter a valid email address",
  "Email is required": "Email is required",
  "Please enter a valid email address.": "Please enter a valid email address.",
  "Last name is required": "Last name is required",
  "Whitespaces are not allowed": "Whitespaces are not allowed",
  "First name is required": "First name is required",
  "The email domain is not permitted for registration.": "The email domain is not permitted for registration.",

  // Content Hub
  "No contents match your current filters.": "No contents match your current filters.",
  "No contents were found.": "No contents were found.",
  "Reset filters or adjust your search to see available content.": "Reset filters or adjust your search to see available content.",
  "Reset filters": "Reset filters",
  "Apply network changes to existing {{ count }} content item": "Apply network changes to existing {{ count }} content item",
  "Apply network changes to existing {{ count }} content items": "Apply network changes to existing {{ count }} content items",
  "Apply this update": "Apply this update",
  "Apply only the network additions or removals made in this update. Other content-level assignments remain unchanged.": "Apply only the network additions or removals made in this update. Other content-level assignments remain unchanged.",
  "Source update:": "Source update:",
  "Refresh runs in the background. Sources with an ongoing source update will refresh after that update finishes. Other sources refresh normally. You can close this dialog and continue working.": "Refresh runs in the background. Sources with an ongoing source update will refresh after that update finishes. Other sources refresh normally. You can close this dialog and continue working.",
  "We are refreshing your Content Hub.": "We are refreshing your Content Hub.",
  "This source is being updated. Try again after the update finishes.": "This source is being updated. Try again after the update finishes.",
  "Previous networks:": "Previous networks:",
  "Pending networks:": "Pending networks:",
  "Eligible existing content:": "Eligible existing content:",
  "Changed existing content:": "Changed existing content:",
  "Queued": "Queued",
  "Processing": "Processing",
  "Completed": "Completed",
  "Failed": "Failed",
  "None": "None",
  "Apply tag changes separately before applying network changes to existing content.": "Apply tag changes separately before applying network changes to existing content.",
  "Choose how to apply these tag and network changes to existing content.": "Choose how to apply these tag and network changes to existing content.",
  "Source update queued. You can close this dialog and return later.": "Source update queued. You can close this dialog and return later.",
  "The source update could not be queued.": "The source update could not be queued.",
  "The source update could not be prepared. Close the source and try again.": "The source update could not be prepared. Close the source and try again.",
  "The confirmation could not be shown, so nothing was changed. Please try again.": "The confirmation could not be shown, so nothing was changed. Please try again.",
  'Retry saved update':
    'Retry saved update',
  'Retry the saved settings, not unsaved edits in this form.':
    'Retry the saved settings, not unsaved edits in this form.',
  'The saved source update could not be retried.':
    'The saved source update could not be retried.',
  'The source changed after this operation failed. Reopen the source before retrying.':
    'The source changed after this operation failed. Reopen the source before retrying.',
  "Source updated. {{ count }} existing content item changed.": "Source updated. {{ count }} existing content item changed.",
  "Source updated. {{ count }} existing content items changed.": "Source updated. {{ count }} existing content items changed.",
  "The source update failed. No changes were saved.": "The source update failed. No changes were saved.",
  "Operation failed. Reopen the source and try again.": "Operation failed. Reopen the source and try again.",
  "The completed source settings could not be refreshed. Close and reopen the source before editing.": "The completed source settings could not be refreshed. Close and reopen the source before editing.",

  // Welcome modal
  "Hi {{ userName }}": "Hi {{ userName }}",
  "Welcome to our social media hub. Take part in sharing all our great stories, news, job posts and more.": "Welcome to our social media hub. Take part in sharing all our great stories, news, job posts and more.",
  "Every share counts.": "Every share counts.",
  "Get started right here": "Get started right here",

  /*
    Admin platform pages
  */

  // Auto-flow / Content Selection
  "Run customization": "Run customization",
  "Thumbnail uploaded.": "Thumbnail uploaded.",
  "Thumbnail removed.": "Thumbnail removed.",

  // PDF preview
  "This PDF could not be previewed. Please check that the file is valid and try again.": "This PDF could not be previewed. Please check that the file is valid and try again.",
  "Password-protected PDFs cannot be previewed. Please upload an unprotected PDF.": "Password-protected PDFs cannot be previewed. Please upload an unprotected PDF.",
  "This PDF preview could not be loaded. Please try again.": "This PDF preview could not be loaded. Please try again.",
  "This PDF could not be previewed. Please try another PDF.": "This PDF could not be previewed. Please try another PDF.",
  "Please wait for the PDF preview to finish loading": "Please wait for the PDF preview to finish loading",

  // Image uploads
  "Image type is not valid": "Image type is not valid",
  "GIF images for LinkedIn must be smaller than 5 MB": "GIF images for LinkedIn must be smaller than 5 MB",
  "LinkedIn image file size exceeds 50 MB limit": "LinkedIn image file size exceeds 50 MB limit",
  "Image dimensions is not valid": "Image dimensions is not valid",
  "Error processing image file": "Error processing image file",
  "Error reading image file": "Error reading image file",

  "Sender identity": "Sender identity",
  "Sender name": "Sender name",
  "Write the name recipients should see as the email sender.": "Write the name recipients should see as the email sender.",
  "AutoFlow default sender": "AutoFlow default sender",
  "Maximum 100 characters.": "Maximum 100 characters.",
  "From:": "From:",
  "Cancel": "Cancel",
  "Save": "Save",
  "Sender name saved.": "Sender name saved.",
  "Support chat is temporarily unavailable. Please try again later.": "Support chat is temporarily unavailable. Please try again later.",
  'Needs an image for {{ networks }}': 'Needs an image for {{ networks }}',
  'and': 'and',
  'Used when this is shared to {{ networks }}.': 'Used when this is shared to {{ networks }}.',
  'On {{ origin }} the original {{ origin }} post is reshared, so these changes don\'t show there.':
    'On {{ origin }} the original {{ origin }} post is reshared, so these changes don\'t show there.',
  'This video is shared only on {{ origin }}, where the original {{ origin }} post is reshared, so these changes don\'t show there.':
    'This video is shared only on {{ origin }}, where the original {{ origin }} post is reshared, so these changes don\'t show there.',
};
